import { Input, Row, Select, Table, Transfer, Typography } from "antd";
import { TransferDirection } from "antd/lib/transfer";
import React from "react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ITransferItemSourceModel } from "shared/models/transfer-item-source-model";
import { redirectFileLocalUrl } from "shared/plugins/string-helper";
import { BranchModel } from "states/branch/branch.models";
import { setLoading } from "states/global-value/global-value.slice";
import { ProductCategoryModel } from "states/product-category/product-category.models";
import {
  searchListProductApi,
  searchProductApi,
} from "states/product/product.api";
import { SearchProductRequestModel } from "states/product/product.models";
import { useDebouncedCallback } from "use-debounce/lib";

export interface IPromotionProductTransferComponentProps {
  productIds: number[];
  onChange: (productIds: number[]) => void;
  categories: ProductCategoryModel[];
  currentTimeZone: string;
}
export function PromotionProductTransferComponent(
  props: IPromotionProductTransferComponentProps
) {
  const { productIds, categories, onChange, currentTimeZone } = props;
  const dispatch = useDispatch();
  const [products, setProductList] = useState<ITransferItemSourceModel[]>();
  const [filterModel, setFilterModel] = useState<SearchProductRequestModel>({
    includeAccessory: true,
    includeChildrenUnitProduct: true,
    includeChildrenVariationProduct: true,
    page: 1,
    pageSize: 20,
    categoryIds: [],
  });
  const [targetKeys, setTargetKeys] = useState<ITransferItemSourceModel[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const gotoPage = async () => {
    dispatch(setLoading(true));
    const result = await searchListProductApi({
      ...filterModel,
      categoryIds: filterModel.categoryIds,
    });
    dispatch(setLoading(false));
    mapFromProductToTarget(
      result.data.map((m) => {
        return {
          key: m.id.toString(),
          description: m.name,
          title: `<img width="50px" height="50px" src="${redirectFileLocalUrl(
            m.images.length > 0 ? m.images[0] : ""
          )}" /> ${m.name} ${m.unit !== null ? "|" + m.unit?.unitName : ""} ${
            m.variationAttributes.length > 0
              ? " | " +
                m.variationAttributes.map((x) => x.variationValue).join(",")
              : ""
          }`,
          disabled: false,
        } as ITransferItemSourceModel;
      })
    );
  };
  const initProduct = async (productIds: number[]) => {
    if (productIds.length === 0) {
      return;
    }
    dispatch(setLoading(true));
    const result = await searchListProductApi({
      ...filterModel,
      productIds: productIds,
    });
    dispatch(setLoading(false));
    mapFromTargetToProduct(
      result.data.map((m) => {
        return {
          key: m.id.toString(),
          description: m.name,
          title: `<img width="50px" height="50px" src="${redirectFileLocalUrl(
            m.images.length > 0 ? m.images[0] : ""
          )}" /> ${m.name} ${m.unit !== null ? "|" + m.unit?.unitName : ""} ${
            m.variationAttributes.length > 0
              ? " | " +
                m.variationAttributes.map((x) => x.variationValue).join(",")
              : ""
          }`,
          disabled: false,
        } as ITransferItemSourceModel;
      })
    );
  };
  const mapFromProductToTarget = (
    sourceProducts: ITransferItemSourceModel[]
  ) => {
    let target = [...targetKeys].map((m) => m.key);
    let newProducts = sourceProducts.filter(
      (m) => !target.includes(m.key.toString())
    );
    setProductList([...newProducts, ...targetKeys]);
  };
  const mapFromTargetToProduct = (targetKeys: ITransferItemSourceModel[]) => {
    setProductList(targetKeys);
    setTargetKeys(targetKeys);
  };
  const handleSearch = useDebouncedCallback(() => {
    gotoPage();
  }, 500);

  useEffect(() => {
    initProduct(productIds);
  }, []);

  useEffect(() => {
    handleSearch();
  }, [filterModel]);
  return (
    <Input.Group>
      <Typography.Text>Danh mục sản phẩm: </Typography.Text>
      <Select
        className="w-100 mb-2"
        placeholder="Chọn danh mục"
        onChange={(value: number) => {
          setFilterModel({ ...filterModel, categoryIds: value ? [value] : [] });
        }}
        allowClear
        showSearch
        filterOption={(input, option: any) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {categories &&
          categories.map((productCate) => (
            <Select.Option key={productCate.id} value={productCate.id}>
              {productCate.name}
            </Select.Option>
          ))}
      </Select>
      <Transfer
        className="transfer-style"
        dataSource={[...(products ?? [])]}
        titles={["Source", "Target"]}
        targetKeys={targetKeys?.map((m) => m.key)}
        selectedKeys={selectedKeys}
        onChange={(nextTargetKeys: string[], direction, moveKeys) => {
          setTargetKeys(
            [...(products ?? [])]?.filter((m) =>
              nextTargetKeys.includes(m.key)
            ) ?? []
          );
          onChange(nextTargetKeys.map((m) => Number(m)));
        }}
        onSelectChange={(
          sourceSelectedKeys: string[],
          targetSelectedKeys: string[]
        ) => {
          setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
        }}
        onScroll={(
          direction: TransferDirection,
          e: React.SyntheticEvent<HTMLUListElement>
        ) => {}}
        render={(item) => (
          <div dangerouslySetInnerHTML={{ __html: item.title }}></div>
        )}
        oneWay
      />
    </Input.Group>
  );
}
